
import { EpimsBaseEntityDto } from "./epim-base.dto";


export class AreaMapOfSpillDto extends EpimsBaseEntityDto{
  AreaMapOfSpillId: string;
  LinkageId: string;
  Date:Date;
  AreaMapSpillDescription:string;
  Remarks:string;
  Url:string;
  SerialNo:string;
  length: number;
}
